import React, { useEffect, useState } from 'react';

import { Switch as SwitchControl } from '@opendoor/bricks/complex';
import { Card, Flex, Text } from '@opendoor/bricks/core';
import { colors } from '@opendoor/bricks/theme/eero';

import { INotificationCategory } from './NotificationPreferences';

interface INotificationPreferenceCardProps {
  key: number;
  notificationPreference: INotificationCategory;
  updateNotificationCategories: (category: string, enabled: boolean) => void;
}
const NotificationPreferenceCard: React.FC<INotificationPreferenceCardProps> = (
  props: INotificationPreferenceCardProps,
) => {
  const { notificationPreference, updateNotificationCategories } = props;
  const [enabled, setEnabled] = useState<boolean>(notificationPreference.enabled);

  const handleEnabledSwitch = () => {
    setEnabled(!enabled);
  };

  useEffect(() => {
    updateNotificationCategories(notificationPreference.categoryKey, enabled);
    // eslint-disable-next-line
  }, [enabled]);

  return (
    <Card
      variant="tertiary"
      border="1px solid"
      borderColor="neutrals40"
      borderRadius="roundedSquare"
      width="100%"
      pl={5}
      mb={5}
      padding={[7, 5]}
    >
      <Flex justifyContent="space-between" alignItems="baseline" width="100%" mb={4}>
        <Text fontWeight="bold" fontSize="s2">
          {notificationPreference.label}
        </Text>
        <SwitchControl checked={enabled} color={colors.brand50} onChange={handleEnabledSwitch} />
      </Flex>
      <div>{notificationPreference.description}</div>
    </Card>
  );
};
export default NotificationPreferenceCard;
